export const ORDER_STATUSES = [
  ["awaiting_payment", "Awaiting Payment"],
  ["paid", "Paid"],
  ["processing", "Processing"],
  ["shipped", "Shipped"],
  ["completed", "Completed"],
  ["cancelled", "Cancelled"],
];

const LABELS = Object.fromEntries(ORDER_STATUSES);

export const statusLabel = (s) => LABELS[s] || s;
